import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import CloseIcon from '@material-ui/icons/Close'
import React, { MouseEvent, useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import colorContext from '../../Context/colorContext'
import { useStyles } from './styles'

interface NavProps {
  label: string
  route?: string
  actionPage?: string
  list: [
    {
      id: number
      titulo: string
      url: string
      slug?: string
      isExternal: boolean
      pagina_slug: string
      pagina_publicado: boolean
    },
  ]
}

const Links = ({ label, route, actionPage, list }: NavProps): JSX.Element => {
  const { colors } = useContext(colorContext)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isClicked, setIsClicked] = useState<boolean>(false)
  const location = useLocation()
  const classes = useStyles({ colors, active: Boolean(anchorEl), isClicked })
  const history = useHistory()
  const menuId = `links-menu-${label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`

  useEffect(() => {
    if (location.pathname !== `/${actionPage}/servicos`) {
      setIsClicked(false)
    }
  }, [actionPage, location.pathname])

  useEffect(() => {
    if (route && location.pathname.includes(route)) {
      setIsClicked(true)
    } else {
      setIsClicked(false)
    }
  }, [location.pathname, route])

  useEffect(() => {
    const handleScroll = (event: Event) => {
      if (anchorEl) {
        const target = event.target as HTMLElement
        // Verifica se o target é um elemento HTML e se o scroll está acontecendo dentro do menu dropdown
        const isMenuScroll =
          target?.closest && target.closest(`#${menuId}`) !== null

        // Só fecha o menu se o scroll NÃO for dentro do dropdown
        if (!isMenuScroll) {
          handleClose()
        }
      }
    }

    if (anchorEl) {
      window.addEventListener('scroll', handleScroll, true)
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, true)
    }
  }, [anchorEl])

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    if (actionPage) {
      history.push(`/${actionPage}/servicos`)
      setIsClicked(true)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = (item: (typeof list)[0]) => {
    handleClose()

    if (!route) {
      const url =
        item.isExternal || item.url
          ? item.url
          : item.pagina_slug
          ? `${process.env.PUBLIC_URL}/pagina/${item.pagina_slug}`
          : null

      if (!url) {
        // Se não houver URL, não faz nada
        return
      }

      if (item.isExternal) {
        window.open(url, '_blank', 'noreferrer')
      } else {
        window.location.href = url
      }
    } else {
      window.location.href = `/${route}/servicos/${item.slug}/categoria/${item.id}`
    }
  }

  // Removido o filtro para exibir todos os submenus
  const filteredList = list || []

  return (
    <>
      <Button
        className={classes.links}
        onClick={handleClick}
        aria-controls={anchorEl ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={anchorEl ? 'true' : undefined}
      >
        {label}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableScrollLock
        PaperProps={{
          style: {
            maxHeight: 400,
            maxWidth: '90vw',
            overflowY: 'auto',
            overflowX: 'hidden',
          },
        }}
      >
        {filteredList.length === 0 ? (
          <MenuItem disabled className={classes.menuItem}>
            <span style={{ flexGrow: 1 }}>Nenhum submenu disponível</span>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                handleClose()
              }}
              className={classes.closeButton}
              aria-label="fechar menu"
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </MenuItem>
        ) : (
          filteredList.map((li, index) => {
            const hasLink = li.url || li.pagina_slug
            return (
              <MenuItem
                key={`${li.id}-${index}`}
                onClick={() => hasLink && handleMenuItemClick(li)}
                className={classes.menuItem}
                style={{
                  opacity: hasLink ? 1 : 0.5,
                  cursor: hasLink ? 'pointer' : 'default',
                }}
                disabled={!hasLink}
              >
                <span style={{ flexGrow: 1 }}>{li.titulo}</span>
                {index === 0 && (
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation()
                      handleClose()
                    }}
                    className={classes.closeButton}
                    aria-label="fechar menu"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </MenuItem>
            )
          })
        )}
      </Menu>
    </>
  )
}

export default Links
